import { render, staticRenderFns } from "./fade-transition.vue?vue&type=template&id=8dfa0072"
import script from "./fade-transition.vue?vue&type=script&lang=js"
export * from "./fade-transition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports